<style lang="scss">
    .picker-input {
        position: relative;
        z-index: 98;

        .picker-fade {
            position: fixed;
            width: 100%;
            height: 100%;
            z-index: 97;
            left: 0;
            top: 0;
        }

        .picker-box {
            position: absolute;
            top: 34px;
            left: 1px;
            z-index: 99;
        }

        .vue-color__swatches {
            height: 195px;

            &__box {
                padding: 10px 0 0 5px!important;
                overflow: hidden;
            }

            &__color-group {
                width: 16.3%!important;
                margin-right: 0!important;
                padding: 0 4px 10px 4px!important;
            }

            &__color-it {
                width: 100%!important;
            }
        }
    }
</style>

<template>
    <div class="input-group picker-input">
        <input v-model="color.hex" class="form-control">
        <a href="#" class="input-group-addon" @click.prevent="showPicker = !showPicker">
            <i class="fa fa-square" :style="`color: ${color.hex}`"></i>
        </a>
        <div class="picker-fade" v-show="showPicker" @click="closePicker"></div>
        <div class="picker-box" v-show="showPicker">
            <picker v-model="color"></picker>
        </div>
    </div>
</template>

<script>
    import { Swatches } from 'vue-color'

    export default {
        props: [ 'value' ],
        data () {
            return {
                showPicker: false,
                color: {hex: ''}
            }
        },
        components: { 'picker': Swatches },
        watch: {
            value (value) {
                if (this.color.hex !== value)
                    this.color.hex = value
            },
            color () {
                let vm = this
                vm.$emit('input', vm.color.hex)
            }
        },
        methods: {
            openPicker () {
                this.showPicker = true
            },
            closePicker () {
                this.showPicker = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/ColorPicker.vue